import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon } from "@ui5/webcomponents-react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ButtonOutlined from "./StyledComponents/ButtonOutlined";
import { Link } from "react-router-dom";
import "@ui5/webcomponents-icons/dist/AllIcons.js";
import httpRequest from "../httpRequest";

const RecentScansCard = ({ invoiceData }) => {
  const [recentScans, setRecentScans] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVendors();
  }, []);

  useEffect(() => {
    if (vendors.length > 0 && invoiceData) {
      const recentScansData = invoiceData
  .sort((a, b) => b.id - a.id) // Sort by descending invoice.id
  .filter(invoice => {
    try {
      JSON.parse(invoice.parsed_data);
      return true; // Keep valid parsed_data
    } catch {
      return false; // Exclude invalid parsed_data
    }
  })
  .slice(0, 7) // Limit to the most recent 7 entries
  .map(invoice => {
    const parsedData = JSON.parse(invoice.parsed_data);
    return {
      ...invoice,
      invoice_number: parsedData["Document Number"] || "N/A",
      invoice_amount: parsedData["Invoice Amount"] || "N/A",
      vendor_name: vendors.find(v => v.vendor_code === invoice.vendor_code)?.vendor_name || "Unknown Vendor"
    };
  });

setRecentScans(recentScansData);

    }
  }, [invoiceData, vendors]);

  const fetchVendors = async () => {
    try {
      const response = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-vendors`);
      setVendors(response.data.vendors);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setError("Failed to load vendor data. Please try again later.");
    }
  };

  return (
    <Card 
      header={<CardHeader avatar={<Icon name="document" />} subtitleText="Most Recent Documents Scanned" titleText="Recent Scans" />}
    >
      {error ? (
        <div style={{ color: "red", textAlign: "center" }}>{error}</div>
      ) : (
        <>
          <TableContainer style={{ height: 445 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontFamily: 'SapFiori72' }}>Document Number</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontFamily: 'SapFiori72' }}>Vendor Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontFamily: 'SapFiori72' }}>Invoice Amount</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontFamily: 'SapFiori72' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontFamily: 'SapFiori72' }}>Scanned</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {recentScans.map((row, index) => (
                  <TableRow hover key={index}>
                    <TableCell sx={{ fontFamily: 'SapFiori72' }}>{row.invoice_number}</TableCell>
                    <TableCell sx={{ fontFamily: 'SapFiori72' }}>
                      <Link to={`/history?vendor_code=${encodeURIComponent(row.vendor_code)}`}>
                        {row.vendor_name}
                      </Link>
                    </TableCell>
                    <TableCell sx={{ fontFamily: 'SapFiori72' }}>{row.invoice_amount}</TableCell>
                    <TableCell sx={{ fontFamily: 'SapFiori72' }}>{row.status}</TableCell>
                    <TableCell sx={{ fontFamily: 'SapFiori72' }}>{row.scan_date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link to={`/history`}>
              <ButtonOutlined style={{ margin: "10px" }}>
                Show All
              </ButtonOutlined>
            </Link>
          </div>
        </>
      )}
    </Card>
  );
};

export default RecentScansCard;
